//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setHours(exdate.getHours() + expiredays);
    // console.log(exdate.getHours(), 'exdate', exdate);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toUTCString());
};
//获取cookie
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return null;
}
//删除cookie
export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getHours() - 2);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

// 获取指定时间的时间戳
function convertTime(nowDate, Deadline) {
    // 分割参数Deadline
    var _dateArr = Deadline.split(':');
    // 分别获取参数中对应的时、分、秒
    var hours = parseInt(_dateArr[0]);
    var minutes = parseInt(_dateArr[1]);
    var seconds = parseInt(_dateArr[2]);
    // 设置对应时分秒
    nowDate.setHours(hours);
    nowDate.setMinutes(minutes);
    nowDate.setSeconds(seconds);
    // 获取当前天中指定时分秒对应的毫秒数
    var result = Date.parse(nowDate);
    return result;
}


// WEBPACK FOOTER //
// ./src/utils/auth.js